module.exports = __webpack_public_path__ + "img/serviceitem_banner.ee7b8f44.jpg";